<template>
<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>地区</th>
								<th>投资方</th>
								<th>编辑</th>
							</tr>
							<tr :key="index" v-for="(list,index) in enterprise_list">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title"
									@click="routerlinkid('/enterprises',list.stockCode,searchtype,'',searchtype)">
									{{list.title}}
								</td>
								<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.notionlist"
										@click="tagrouter('/enterpriseTag',searchtype,'notion',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td class="conpanytags hastag1" v-show="list.tag!=''">
									<span class="span-tag" :key="i1" v-for="(item,i1) in list.taglist"
										@click="tagrouter('/enterpriseTag',searchtype,'tag',item.id,item.name,'quality2')">{{item.name}}</span>
								</td>
								<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
									<div class="" style="color: #999;">-</div>
								</td>
								<td>{{list.financingRound[0].rount}}</td>
								<td>{{list.financingRound[0].time}}</td>
								<td>{{list.financingRound[0].amount}}</td>
								<td>{{list.area}}</td>
								<td class="orglist ">
									<p v-if="list.financingRound[0].id!='none'">
										<span :key="inds" v-for="(org,inds) in list.financingRound[0].orgList"
											data="org.id" :class="org.id!=0?'curp':''"
											@click="routerlinkid('investement-enterprises',org.id)">{{org.orgName}}<i
												v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span>
									</p>
									<p v-if="list.financingRound[0].id=='none'">-</p>
								</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
</template>

<script>
	export default {
		name: 'domesticTable',
		data() {
			return {
				 enterprise_list:[]
		}},
		props:{
			list:{type:Array,defalt:[]},
		},
		created() {
			this.enterprise_list=this.list;
		}
	}
</script>

<style>
</style>